import PlatformError from "../PlatformError";

export default new PlatformError(
  "ERROR",
  "Connection speed was determined to be too low.",
  "Screenout",
  "Request timed out after 30 seconds",
  "app.error.lowconnectionspeed"
);
